import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutocompleteDropdownComponent } from '@app/shared/autocomplete-dropdown/autocomplete-dropdown.component';
import { Labels } from '@core/constants/labels';
import { FilterDataImages } from '@core/models/filter-data-images.model';
import { ImageTag } from '@core/models/image-tag.model';
import { SlideService } from '@core/services/slide-service/slide-service.service';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-image-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
    AutocompleteDropdownComponent,
  ],
  templateUrl: './image-filter.component.html',
  styleUrl: './image-filter.component.scss',
})
export class ImageFilterComponent implements OnDestroy, OnInit {
  labels = Labels.IMAGE_FILTER;

  avaliableTags: ImageTag[] = [];
  includeTags: ImageTag[] = [];
  excludeTags: ImageTag[] = [];
  selectedTag: ImageTag = { id: -1, name: '', name_search: '' };

  subscriptions = new Subscription();

  constructor(private slideService: SlideService) {}

  ngOnInit() {
    const currentDataDub = this.slideService
      .getAvaliableTags()
      .subscribe((tags) => {
        this.avaliableTags = tags;
      });
    this.subscriptions.add(currentDataDub);
    this.slideService.updateFilters(new FilterDataImages()); // reset filters
  }

  displayTagFn(tag: ImageTag): string {
    return tag && tag.name ? tag.name : '';
  }

  onTagSelectionChange(tag: ImageTag) {
    this.selectedTag = tag;
  }

  addIncludeFilterTag() {
    if (
      this.selectedTag.id > 0 &&
      this.includeTags.indexOf(this.selectedTag) < 0
    ) {
      this.includeTags.push(this.selectedTag);
      this.updateFilterData();
    }
  }

  addExcludeFilterTag() {
    if (
      this.selectedTag.id > 0 &&
      this.excludeTags.indexOf(this.selectedTag) < 0
    ) {
      this.excludeTags.push(this.selectedTag);
      this.updateFilterData();
    }
  }

  removeIncludeFilterTag(tag: ImageTag) {
    this.includeTags.splice(this.includeTags.indexOf(tag), 1);
    this.updateFilterData();
  }

  removeExcludeFilterTag(tag: ImageTag) {
    this.excludeTags.splice(this.excludeTags.indexOf(tag), 1);
    this.updateFilterData();
  }

  updateFilterData() {
    const currentFilterData = this.slideService.filterData;
    currentFilterData.includeTagIds = this.includeTags.map((tag) => tag.id);
    currentFilterData.excludeTagIds = this.excludeTags.map((tag) => tag.id);
    this.slideService.updateFilters(currentFilterData);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
